/**
 * 权限清单
 */
export default {
  haveEveryAuth (needAuth, allAuth) {
    if (allAuth === null || !allAuth.length) return false
    return needAuth.every(v => {
      return allAuth.includes(v)
    })
  },
  haveSomeAuth (needAuth, allAuth) {
    if (allAuth === null || !allAuth.length) return false
    return needAuth.some(v => {
      return allAuth.includes(v)
    })
  },
  // 离店登记
  leaveStore: {
    car_visit_checkout: 'car_visit.checkout',
    // 无牌放行
    car_visit_checkout_confirm: 'car_visit.checkout_confirm'
  },
  // 销售管理
  saleManage: {
    // 跟进线索
    sale_clue_follow_up: 'sale_clue.follow_up',
    // 跟进个人名下线索
    sale_clue_follow_self: 'sale_clue.follow_self',
    // 跟进全部线索
    sale_clue_follow_all: 'sale_clue.follow_all',
    // 查看线索
    sale_clue_view: 'sale_clue.view',
    // 查看个人线索
    sale_clue_view_self: 'sale_clue.view_self',
    // 查看全部线索
    sale_clue_view_all: 'sale_clue.view_all',
    // 转交线索
    sale_clue_transfer: 'sale_clue.transfer',
    // 线索设为无效
    sale_clue_cancel: 'sale_clue.cancel',
    // 线索设为休眠
    sale_clue_suspend: 'sale_clue.suspend',
    // 导入客户
    sale_potential_customer_import: 'sale_potential_customer.import',
    // 跟进客户
    sale_potential_customer_follow_up: 'sale_potential_customer.follow_up',
    // 查看客户
    sale_potential_customer_view: 'sale_potential_customer.view',
    // 查看个人客户
    sale_potential_customer_view_self: 'sale_potential_customer.view_self',
    // 查看全部客户
    sale_potential_customer_view_all: 'sale_potential_customer.view_all',
    // 线索分配与激活
    sale_clue_activate_assign: 'sale_clue.activate_assign',
    // 客户管理与签单审核
    sale_potential_customer_manage: 'sale_potential_customer.manage',
    // 客流登记与分配
    store_visit_manage: 'store_visit.manage',
    // 基础数据配置
    sales_basic_data_manage: 'sales_basic_data.manage'
  },
  busiAnalysis: {
    // 门店资料权限
    store_manage_profile: 'store.manage_profile',
    // 二手车业务统计
    busi_analysis_zs_used_car_ticket: 'busi_analysis.zs_used_car_ticket',
    // 到店车辆建线索
    zs_used_car_ticket_create_from_car_visit: 'zs_used_car_ticket.create_from_car_visit',
    // 二手车收车线索跟进
    zs_used_car_ticket_manage: 'zs_used_car_ticket.manage',
    // 二手车拍卖
    auction_car_view: 'auction_car.view',
    // 销售统计
    busi_analysis: 'busi_analysis.sale',
    // 查看本店范围权限
    view_self: 'report.view_self',
    // 车辆进出店统计
    visit_car: 'busi_analysis.car_visit',
    // 粉丝运营统计
    fans_analysis: 'busi_analysis.fans',
    // 续保统计
    insurance_analysis: 'busi_analysis.insurance'
  },
  /** 售后服务 */
  aftersales: {
    /** 新增联系人 */
    customer_contacts_add: 'base_car.customer_contacts.add',
    /** 新增车辆 */
    base_car_add: 'base_car.add'
  },
  serviceBooking: {
    /** 额外增约 */
    add_extra: 'service_booking.add_extra',
    /** 更换跟进人 */
    receiver_change: 'service_booking.receiver_change'
  }
}
